import { render, staticRenderFns } from "./GenreActorList.vue?vue&type=template&id=47a29bfe"
import script from "./GenreActorList.vue?vue&type=script&lang=js"
export * from "./GenreActorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports